export const MENU_BANNER_EDITOR_TITLE = 'Menu Banner';
export const MENU_BANNER_EDITOR_DETAIL_COPY =
  'Display a message above your menu with important information for customers.';

export const AGE_VERIFICATION_BANNER_EDITOR_TITLE = 'Age Verification Banner';
export const AGE_VERIFICATION_BANNER_EDITOR_DETAIL_COPY =
  'Display a message for customers who are pending review for age verification.';
